import { isAxiosError } from "axios";
import { format } from "date-fns";
import i18n, { t } from "i18next";
import axios from "../lib/axios";
import { SummaryOfPresencesHoursInProjectEntry } from "../types";

export const getSummaryOfPresencesHoursInProject = async (
  projectId: number,
  from: Date,
  to: Date,
  companyId?: number,
): Promise<SummaryOfPresencesHoursInProjectEntry[]> => {
  try {
    const { data } = await axios.get<SummaryOfPresencesHoursInProjectEntry[]>(
      "/api/presences/summary-of-hours-by-project",
      {
        headers: {
          "Accept-Language": i18n.language,
        },
        params: {
          projectId,
          from: format(from, "yyyy-MM-dd"),
          to: format(to, "yyyy-MM-dd"),
          companyId,
        },
      },
    );

    return data;
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};
